import { render, staticRenderFns } from "./navigation_tabs.vue?vue&type=template&id=0d7efa2c&"
import script from "./navigation_tabs.vue?vue&type=script&lang=js&"
export * from "./navigation_tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "navigation_tabs.vue"
export default component.exports